export default __webpack_public_path__ + "static/media/pagePhoto4.35c2f8f8.png";